import { Accent, Reveal } from "@/components/Reveal";

const PageHero = ({ image, eyebrow, title, text }) => (
  <section className="relative h-[52vh] min-h-[420px] flex items-end overflow-hidden">
    <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F14] via-[#0B0F14]/55 to-black/40" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pb-14 w-full">
      <Reveal y={24}>
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="font-sora text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] mt-4 max-w-3xl">
          {title}
        </h1>
        {text && <p className="text-base text-[#F5F5F0]/70 max-w-xl mt-5 leading-relaxed">{text}</p>}
      </Reveal>
    </div>
  </section>
);

export { Accent };
export default PageHero;
